import React from "react"

export const ArrowNextIcon = () => {
  return (
    <svg width="9" height="18" viewBox="0 0 9 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.776094 18C0.973354 18 1.17061 17.9273 1.32635 17.7716L8.09549 11.0025C9.196 9.90195 9.196 8.09546 8.09549 6.99496L1.32635 0.225811C1.02526 -0.0752704 0.526923 -0.0752704 0.225842 0.225811C-0.0752399 0.526893 -0.0752399 1.02523 0.225842 1.32632L6.99499 8.09546C7.49333 8.5938 7.49333 9.40361 6.99499 9.90195L0.225842 16.6711C-0.0752399 16.9722 -0.0752399 17.4705 0.225842 17.7716C0.381573 17.9169 0.578834 18 0.776094 18Z" fill="#292D32"/>
    </svg>
  )
}
